(() => {
  "use strict";

  const originSelector = ".ecom-banner__picture-link[href*='/products/jeu-echecs-origine']";

  function prepareOriginSliders(root = document) {
    const links = [];
    if (root instanceof HTMLAnchorElement && root.matches(originSelector)) links.push(root);
    if (root instanceof Element || root instanceof Document) {
      links.push(...root.querySelectorAll(originSelector));
    }

    links.forEach((link) => {
      const frame = link.querySelector(".ecom-banner__image-picture");
      if (frame) frame.classList.add("ecom-origin-featured-slide");

      const slider = link.closest(".ecom-elements-slider");
      if (!slider) return;

      // Swiper keeps off-screen slides transformed; eager loading prevents blank cards on mobile.
      slider.querySelectorAll("img[loading='lazy']").forEach((image) => {
        image.loading = "eager";
      });
    });
  }

  function initialize() {
    prepareOriginSliders();

    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) prepareOriginSliders(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
